// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ix","heading":"jx"};